import { ListItemIcon, styled } from "@mui/material";

export const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 30px;
`;
